import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import shallow from 'zustand/shallow'

export const useDependencies = create(
  persist(
    (set) => ({
      setDependency: (dependencies, role, roleId) => {
        set(() => ({
          ...dependencies,
          role: role,
          roleId: roleId,
        }))
      },
      unsetDependency: (dependecies, role, roleId) => {
        const depends = dependecies
        depends['dependencies'] = {}
        depends['role'] = role
        depends['roleId'] = roleId
        set(
          () => ({
            ...depends,
          }),
          shallow,
        )
      },
    }),
    {
      name: 'auth',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)

export const useUnsetDependencies = create(
  persist(
    (set) => ({
      unsetDependency: (role, roleId) => {
        set(() => ({
          role: role,
          roleId: roleId,
          dependeciesFormAPIS: {},
        }))
      },
    }),
    {
      name: 'auth',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
